"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.VolumeDiscountTitle = exports.VolumeDiscount = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
const Typography_1 = __importDefault(require("../../../UI/Typography"));
exports.VolumeDiscount = styled_components_1.default.div `
  width: 100%;
  margin-top: ${props => props.theme.spacing.s4}px;
  padding: ${props => props.theme.spacing.s2}px;
  border: 1px solid ${props => props.theme.palette.BLUE_40};
  background: ${props => props.theme.palette.BLUE_10};
  > div {
    display: flex;
    justify-content: space-between;
  }
`;
exports.VolumeDiscountTitle = (0, styled_components_1.default)(Typography_1.default) `
  color: ${props => props.theme.palette.LIGHT_BLACK};
  font-weight: ${props => props.theme.typography.weight.medium};
`;
exports.default = { VolumeDiscount: exports.VolumeDiscount, VolumeDiscountTitle: exports.VolumeDiscountTitle };
